import { closeIconV2 } from '@/shared/ui/assets';
import { CustomButton, LoadingDrawer } from '@/shared/ui/components';
import { Drawer } from 'antd';
import classNames from 'classnames';
import _ from 'lodash';
import { ReactSVG } from 'react-svg';
import { t } from 'ttag';
import { usePatientInfoDrawer } from './usePatientInfoDrawer';
import type { PatientInfoDrawerProps } from './patientInfoDrawer.types';

const PatientInfoDrawer = ({
  studyId,
  visible,
  isDeletedStudy = false,
  handleClickCloseButton,
}: PatientInfoDrawerProps) => {
  const { state, handleScroll } = usePatientInfoDrawer({
    studyId,
    visible,
    isDeletedStudy,
    handleClickCloseButton,
  });

  const closeButton = (
    <CustomButton
      id="close-btn"
      style="neutral"
      type="tertiary"
      size="small"
      icon={<ReactSVG src={closeIconV2} />}
      onClick={handleClickCloseButton}
      ariaLabel={t`Close`}
    />
  );

  return (
    <Drawer
      id="patient-info-drawer-id"
      aria-label={
        typeof state.data[0]?.content[0]?.value === 'string'
          ? state.data[0]?.content[0]?.value
          : t`Patient info`
      }
      rootClassName="custom-drawer"
      width={500}
      closable={false}
      onClose={handleClickCloseButton}
      open={visible}
    >
      <LoadingDrawer isLoading={state.isLoading} rightIcon={closeButton}>
        <div
          className={classNames('drawer-title-container', state.isScroll ? '--has-box-shadow' : '')}
        >
          <span className="drawer-title">{state.data[0]?.content[0]?.value}</span>
          {closeButton}
        </div>

        <div className="drawer-body-container" onScroll={handleScroll} id="drawer-body-container">
          {_.map(
            _.filter(state.data, (x) => !_.isEmpty(x)),
            (element, index) => (
              <div key={index} className="drawer-body">
                {!!element.header && (
                  <div className="drawer-header">
                    <span>{element.header}</span>
                  </div>
                )}

                <div className="drawer-content">
                  {_.map(
                    _.filter(element.content, (x) => !_.isEmpty(x)),
                    (item, index) => (
                      <div key={index} className="drawer-item">
                        <span>{`${item.label}:`}</span>
                        <span className={item.className}>{item.value}</span>
                      </div>
                    ),
                  )}
                </div>
              </div>
            ),
          )}

          <div className="additional-div" />
        </div>
      </LoadingDrawer>
    </Drawer>
  );
};

export default PatientInfoDrawer;
